import React from "react";
import { ElasticProduct, useProductPrice } from "@usereactify/search";

type Props = {
  product: ElasticProduct;
  itemRef: (node?: Element | null) => void;
};

export const InstantSearchItem: React.FC<Props> = ({ product, itemRef }) => {
  const { formattedPrice, formattedCompareAtPrice, onSale } = useProductPrice(product);

  return (
    <div
      className="grid-item grid-product result"
      ref={itemRef}
      data-product-handle={product.handle}
      data-product-id={product.id}
    >
      <div className="grid-item__content">
        <a href={`/products/${product.handle}`} title={product.title} className="flex flex-col h-full grid-item__url">
          {product.image && <img className="mb-4" src={product.image} alt={product.title} />}
          <p className="small">{product.title}</p>

          <div className="grid-product__price">
            <span className="grid-product__price--current">{formattedPrice?.split(".")[0]} </span>
            {onSale && <span className="opacity-40 line-through"> {formattedCompareAtPrice?.split(".")[0]}</span>}
          </div>
        </a>
      </div>
    </div>
  );
};
